<template>
  <v-container fluid class="font">
    <!--BEGIN remarking policy-->
    <v-dialog
      persistent
      v-model="remarkPolicyDialog"
      max-width="50%"
      height="70vh"
      class="exemptions"
      :fullscreen="$vuetify.breakpoint.mobile"
    >
      <v-card>
        <v-card-text class="summary">
          <v-row class="image">
            <v-col cols="12" md="2" class="text-center">
              <v-img
                width="150"
                height="150"
                alt="disclaimer"
                class="text-center"
                src="../../../../../assets/images/warning.png"
              />
            </v-col>
            <v-col cols="12" md="10">
              <div class="ma-4">
                <p style="color: red" class="font-weight-bold">
                  DISCLAIMER! READ THE FOLLOWING REMARKING POLICY TO PROCEED!
                </p>
                <v-divider class="my-2" />
                <v-list class="exemptions">
                  <v-list-item v-for="(item, i) in remarkingPolicy" :key="i">
                    <p>
                      <v-icon>mdi-menu-right</v-icon>
                      {{ item.text }}
                    </p>
                  </v-list-item>
                </v-list>
              </div>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider />

        <v-card-actions class="exemptions">
          <v-row>
            <v-col cols="12" md="6" sm="12" class="col1">
              <v-btn
                text
                @click="$router.back()"
                class="mt-md-3 custom-class error mb-sm-3"
              >
                <v-icon left> mdi-arrow-left </v-icon>
                Exit
              </v-btn>
            </v-col>
            <v-col cols="12" md="6" sm="12" class="col2 d-flex justify-center">
              <v-checkbox @click="closePolicyDialog()">
                <template v-slot:label>
                  <div>
                    I agree to KISEB
                    <a
                      target="_blank"
                      href="https://kiseb.or.ke/sites/default/files/KISEB/docs/APPEAL-FOR-REMARKING.pdf"
                      class="text-decoration-none"
                    >
                      Remarking Policy
                    </a>
                  </div>
                </template>
              </v-checkbox>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--END remarking policy-->
    <v-card flat>
      <v-card-title>
        <v-btn text small @click="$router.back()">
          <v-icon left> mdi-arrow-left </v-icon>
          Back
        </v-btn>
        <v-spacer />
        Remarking Appeal Application
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-form ref="remarkForm" v-model="isValid">
          <div class="mb-2 text-h6 font-weight-bold">Student Information</div>
          <v-row>
            <v-col cols="12" md="3" sm="6">
              <v-text-field
                label="Profile Number"
                dense
                v-model="formData.profileID"
                readonly
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3" sm="6">
              <v-text-field
                label="Registration Number"
                dense
                v-model="formData.studentNo"
                readonly
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3" sm="6">
              <v-text-field
                label="Programme"
                v-model="formData.programme"
                dense
                readonly
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3" sm="6">
              <v-text-field
                label="Stage"
                dense
                readonly
                outlined
                v-model="formData.stage"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <!--BEGIN List of selected Units-->
              <div class="d-flex justify-space-between">
                <div class="text-h6 font-weight-bold">
                  Examination paper(s) appealed for remarking
                </div>
                <div>
                  <v-btn
                    color="primary"
                    class="text-capitalize"
                    v-if="!isReadonly"
                    @click="remarkUnitsDialogBox = true"
                  >
                    <v-icon left> mdi-plus </v-icon>
                    Select Examination Paper(s)
                  </v-btn>
                </div>
              </div>
              <v-data-table
                :headers="headers"
                :items="formData.examRemarkLines"
                item-key="id"
                class="itemRow"
                :sort-by="['dueDate']"
                :sort-desc="[false]"
                :items-per-page="5"
              >
                <template v-slot:[`item.unit`]="{ item }">
                  {{ item.unit }}
                </template>
                <template v-slot:[`item.examCenter`]="{ item }">
                  {{
                    item.examCenters
                      ? `${item.examCenters.Name}(${item.examCenters.Code})`
                      : ""
                  }}
                </template>
                <template v-slot:[`item.examDate`]="{ item }">
                  {{ item.examDate ? formatDate(item.examDate) : "" }}
                </template>
                <template v-slot:[`item.stageCode`]="{ item }">
                  {{ item.lineNo ? item.stage : item.stageCode }}
                </template>
                <template v-slot:[`item.action`]="{ item, index }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        small
                        color="deep-orange lighten-1"
                        v-if="!isReadonly"
                        @click="removeLine(item, index)"
                      >
                        <!-- <span class="table-exam"> Remove Unit</span> -->
                        <v-icon>delete</v-icon>
                      </v-btn>
                    </template>
                    <span>Remove Unit</span>
                  </v-tooltip>
                </template>
              </v-data-table>
              <!--END List of selected Units-->
            </v-col>
            <div class="d-flex justify-space-between">
              <div>Upload Signed Kiseb Remarking Apeal Form</div>
            </div>
            <v-col cols="12">
              <div class="attachment--documents">
                <v-chip-group
                  active-class="orange darken-2"
                  column
                  multiple
                  class="mx-2"
                >
                  <v-chip
                    v-for="(item, i) in attachments"
                    :key="i"
                    color="primary"
                    outlined
                    label
                    :disabled="isReadonly"
                  >
                    <v-btn
                      left
                      color="primary"
                      class="text-capitalize"
                      text
                      @click="editAttachment(item, i)"
                      :disabled="isReadonly"
                    >
                      {{ item.fileName }}
                    </v-btn>
                    <v-divider vertical></v-divider>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ attrs, on }">
                        <v-btn
                          class="py-2 ml-4"
                          icon
                          :disabled="isReadonly"
                          right
                          v-on="on"
                          v-bind="attrs"
                          color="deep-orange"
                          @click="removeAttachment(i, item)"
                        >
                          <v-icon>delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Remove Attachment</span>
                    </v-tooltip>
                  </v-chip>
                </v-chip-group>
                <div
                  class="d-flex justify-center flex-column"
                  v-if="
                    formData.examRemarkLines &&
                    formData.examRemarkLines.length > 0
                  "
                >
                  <div
                    :class="
                      attachments.length !== 0
                        ? 'align-self-center mt-3'
                        : 'align-self-center'
                    "
                  >
                    <RemarkAttachments
                      :isEdit="isEdit"
                      :BtnCaption="BtnCaption"
                      @addAttachment="addAttachment"
                      :isReadonly="isReadonly"
                      :data="displayAttachment"
                    />
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-form>
        <v-divider />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          elevation="0"
          v-if="!isEdit && !isReadonly"
          :disabled="formData.examRemarkLines.length === 0"
          color="primary"
          class="text-capitalize mb-5"
          @click="saveRemarkUnits"
        >
          <v-icon left> mdi-send </v-icon>
          <span>Save and Proceed To Payments</span>
        </v-btn>
        <v-btn
          v-if="isEdit && !isReadonly"
          class="text-capitalize mb-5"
          color="primary"
          @click="updateRemark"
        >
          <v-icon left> mdi-send </v-icon>
          <span
            >Save
            {{
              formData.postedReceiptNo === "" ? "and Proceed To Payment" : ""
            }}</span
          >
        </v-btn>
      </v-card-actions>
    </v-card>
    <!--BEGIN remarking units dialog-->
    <RemarkUnitsDialog
      :remarkUnitsDialogBox="remarkUnitsDialogBox"
      @setRemarkUnitsModal="setRemarkUnitsModal"
      :formData="formData"
    />
  </v-container>
</template>

<script>
import RemarkUnitsDialog from "./RemarkUnitsDialog";
import { helper } from "@/packages/dashboard/utils";
import { AuthService } from "@brainspore/celadon-base/modules/auth";
import RemarkAttachments from "./RemarkAttachments";
import remarkingPolicy from "../remarkingPolicy";
export default {
  name: "RemarkCard",
  components: { RemarkUnitsDialog, RemarkAttachments },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      if (to.params.code) {
        v.$store.dispatch("Remark/getExamRemark", to.params.code);
        window.document.title = "KISEB::View Remark Details";
      } else {
        window.document.title = "KISEB::Apply For Remarking";
      }
      v.$store.dispatch("Exemption/getExemptionGradesSetup");
      v.$store.dispatch("Remark/remarkUnits");
    });
  },
  data: () => ({
    attachments: [],
    displayAttachment: {},
    isValid: false,
    submitting: false,
    remarkUnitsDialogBox: false,
    remarkPolicyDialogBox: false,
    currentUnit: {},
    formData: {
      profileID: "",
      studentNo: "",
      programme: "",
      stage: "",
      attachmentAPI: [],
      examRemarkLines: [],
      gradeScored: "",
    },
  }),
  created() {
    if (!this.$route.params.code) {
      this.remarkPolicyDialogBox = true;
    }
  },
  mounted() {
    Event.$on("goToPayment", (code) => {
      this.$router.replace({
        name: "RemarkPayments",
        params: { code: code },
      });
    });
  },
  computed: {
    remarkingPolicy: function () {
      return remarkingPolicy;
    },
    remarkPolicyDialog: {
      get() {
        return this.remarkPolicyDialogBox;
      },
      set(value) {
        this.setRemarkPolicyModal(value);
      },
    },
    BtnCaption() {
      return this.attachments.length === 0
        ? "Attach Signed Remarking Apeal Documents"
        : "Add Signed Remarking Apeal Document";
    },
    remark() {
      return this.$store.getters["Remark/remarkGetter"]("remark");
    },
    remarkUnits() {
      return this.$store.getters["Remark/remarkGetter"]("remarkUnits");
    },
    headers() {
      return [
        {
          text: "Unit",
          align: "left",
          sortable: false,
          value: "unit",
        },
        {
          text: "Paper",
          align: "left",
          sortable: false,
          value: "paper",
        },
        {
          text: "Exam Center",
          align: "left",
          sortable: false,
          value: "examCenter",
        },
        {
          text: "Exam Date",
          align: "left",
          sortable: false,
          value: "examDate",
        },
        {
          text: "Scored Grade",
          align: "left",
          sortable: false,
          value: "gradeScored",
        },
        {
          text: "Actions",
          align: "center",
          sortable: false,
          value: "action",
        },
      ];
    },
    isEdit() {
      return this.$route.params.code && this.formData.status === "Open";
    },
    isReadonly() {
      return this.$route.params.code && this.formData.status !== "Open";
    },
    // this computed value returns the programme name and the stage
    student() {
      return AuthService.user.student;
    },
    profile() {
      return AuthService.user.profile;
    },
  },
  methods: {
    encryptedPaymentParam(item) {
      return helper.encrypt(item);
    },
    setAttachmentDialog(val) {
      this.$store.dispatch("Remark/setAttachmentDialog", val);
    },
    closePolicyDialog() {
      this.remarkPolicyDialog = false;
    },
    editAttachment(val, index) {
      val.index = index;
      this.displayAttachment = val;
      this.setAttachmentDialog(true);
    },
    removeAttachment(index, item) {
      if (item.lineNo) {
        // delete remark line
        this.$confirm.show({
          title: `Delete Remark Attachment ${item.lineNo}?`,
          text: "Are you sure you want to delete this remark Attachment, this action is irreversible",
          onConfirm: () => {
            this.$store.dispatch("Remark/deleteAttachment", { ...item });
          },
        });
      } else {
        this.attachments.splice(index, 1);
      }
    },
    async addAttachment(file) {
      this.displayAttachment = {};
      if (file.index !== undefined) {
        Object.assign(this.attachments[file.index], file);
        delete this.attachments[file.index].index;
      } else {
        delete file.index;
        this.attachments.push(file);
      }
    },
    // set remarked units dialog
    setRemarkUnitsModal: function (value) {
      this.remarkUnitsDialogBox = value;
    },
    // set remark policy dialog
    setRemarkPolicyModal: function (value) {
      this.remarkPolicyDialogBox = value;
    },
    // save the remarked units
    saveRemarkUnits: function () {
      this.submitting = true;
      if (!this.isValid) {
        this.$refs.remarkForm.validate();
        this.submitting = false;
      } else if (this.attachments.length === 0) {
        this.$alert({
          text: "Attach Remark Appeal Form to proceed!",
        });
      } else if (
        this.formData.examRemarkLines.filter((el) => el.gradeScored).length !==
        this.formData.examRemarkLines.length
      ) {
        this.$alert({
          text: "Grade is required for remarked units!",
        });
      } else {
        const data = { ...this.formData };
        Array.prototype.push.apply(data.attachmentAPI, this.attachments);
        data.examRemarkLines = data.examRemarkLines.map((el) => {
          return {
            unit: el.unit,
            gradeScored: el.gradeScored,
          };
        });
        this.$store.dispatch("Remark/examRemark", {
          ...data,
        });
      }
    },
    updateRemark: function () {
      this.submitting = true;
      if (!this.isValid) {
        this.$refs.remarkForm.validate();
        this.submitting = false;
      } else if (this.attachments.length === 0) {
        this.$alert({
          text: "Attach supporting documents to proceed!",
        });
      } else if (
        this.formData.examRemarkLines.filter((el) => el.gradeScored).length !==
        this.formData.examRemarkLines.length
      ) {
        this.$alert({
          text: "Grade is required for remarked units!",
        });
      } else {
        const data = { ...this.formData };
        delete data.documentDate;
        delete data.amount;
        delete data.amountLCY;
        data.attachmentAPI = [];
        Array.prototype.push.apply(data.attachmentAPI, this.attachments);
        data.examRemarkLines = data.examRemarkLines.map((el) => {
          return {
            ...el,
            unit: el.unit,
          };
        });
        this.$store.dispatch("Remark/patchRemark", {
          ...data,
        });
      }
    },
    removeLine: function (item, index) {
      if (item.lineNo) {
        // delete remark line
        this.$confirm.show({
          title: `Delete Remark Unit/Paper ${item.lineNo}?`,
          text: "Are you sure you want to delete this remark paper, this action is irreversible",
          onConfirm: () => {
            this.$store.dispatch("Remark/deleteLine", { ...item });
          },
        });
      } else {
        this.formData.examRemarkLines.splice(index, 1);
      }
    },
    formatDate(date) {
      return helper.getDateFormat(date);
    },
    updateLines() {
      this.formData.examRemarkLines = this.formData.examRemarkLines.map(
        (el) => {
          const unit = this.remarkUnits
            .filter((item) => item.unit === el.unit)
            .shift();
          return { ...unit, ...el };
        },
      );
    },
  },
  watch: {
    remark: {
      handler: function (data) {
        const attachments = data.attachmentAPI;
        delete data.attachmentAPI;
        this.formData = { ...data };
        const base64Attachments = [];
        attachments.map(async (el) => {
          const blob = await helper.getFileBlob(
            process.env.VUE_APP_TEMP_URL + el.base64Attachment,
            el.documentNo,
          );
          const base64 = await helper.toBase64(blob);
          base64Attachments.push({
            base64Attachment: base64.split(",")[1],
            fileName: `${blob.name}${el.lineNo}.${blob.type.split("/")[1]}`,
            comment: el.comment,
            blob,
            lineNo: el.lineNo,
            documentNo: el.documentNo,
            documentType: el.documentType,
          });
        });
        this.attachments = base64Attachments;
        this.updateLines();
      },
    },
    remarkUnits() {
      this.updateLines();
      this.formData.programme = this.remarkUnits[0].programme;
      this.formData.stage = this.remarkUnits[0].stage;
      this.formData.profileID = this.profile["profileID"];
      this.formData.studentNo = this.student["no"];
    },
  },
};
</script>

<style scoped>
.font {
  font-family: "PT Sans Caption", sans-serif;
}
.attachment--documents {
  border-radius: 4px;
  padding: 1% 0 1% 0;
  border: 3px dashed green;
  background: #388e3c17;
}
@media all and (max-width: 480px) {
  .custom-class {
    width: 100%;
    display: block;
    margin-top: 0px;
  }
  .col1 {
    order: 2;
  }
  .col2 {
    order: 1;
  }
}
</style>
